<template>
    <div class="main">
        <tabulacao-form
            tipo="BASE"
            :turma-id="$route.params.turmaId"
            :periodo-id="$route.params.periodoId"
            voltar-para="/admin/tabulacao/professor/base">
        </tabulacao-form>
    </div>
</template>

<script>
import TabulacaoForm from '@/components/tabulacao/shared/tabulacao-form.vue'

export default {
    components: { TabulacaoForm }
}
</script>
